<template>
  <div class="wrapper">
    <Sidebar />
    <div class="main">
      <Topbar />
      <main class="content">
        <div class="container-fluid p-0">
          <router-view />
        </div>
      </main>
      <footer class="footer" style="background: #495057">
        <div class="container-fluid">
          <div class="row text-muted">
            <div class="col-6 text-left">
              <ul class="list-inline">
                <li class="list-inline-item">
                  <a class="text-muted" href="">Ajuda</a>
                </li>
                <li class="list-inline-item">
                  <a class="text-muted" href="">Contato</a>
                </li>
              </ul>
            </div>
            <div class="col-6 text-right">
              <p class="mb-0">
                © 2020 -
                <a
                  href="http://layer7tecnologia.net.br/"
                  target="_blank"
                  class="text-muted"
                  >desenvolvido por: Layer7 Tecnologia | V1.2 BETA</a
                >
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import Topbar from "@/components/Topbar.vue";

export default {
  name: "App",
  components: {
    Sidebar,
    Topbar
  }
};
</script>
